export const tr = {
    'name-cis-time-zone': 'BDT',
    'name-russia-time-zone': 'Rusya',
    'name-world-time-zone': 'Tüm Dünya'
};
